// // src/utils/draftTiptapConverter.js

// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';
// import { ContentState, convertToRaw } from 'draft-js';

// /**
//  * Clean HTML string (remove excessive breaks/divs).
//  */
// function cleanHTML(html) {
//     return html
//         .replace(/<p><br><\/p>/g, '<p></p>')
//         .replace(/<div><br><\/div>/g, '<p></p>')
//         .replace(/&nbsp;/g, ' ')
//         .trim();
// }

// /**
//  * Draft.js raw JSON → HTML → sanitized string
//  */
// export function draftRawToHTML(draftJSONString) {
//     if (!draftJSONString) return '<p></p>';

//     try {
//         const raw = JSON.parse(draftJSONString);

//         // Handle empty content safely
//         if (!raw.blocks || raw.blocks.length === 0) return '<p></p>';

//         const html = draftToHtml(raw);
//         return cleanHTML(html);
//     } catch (err) {
//         console.error('Error converting Draft.js → HTML:', err);
//         return '<p></p>';
//     }
// }

// /**
//  * Tiptap HTML → Draft.js raw JSON
//  */
// export function tiptapHTMLToDraftRaw(html) {
//     const clean = cleanHTML(html);
//     const { contentBlocks, entityMap } = htmlToDraft(clean);
//     const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
//     return convertToRaw(contentState);
// }

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, convertToRaw } from 'draft-js';

/**
 * Normalize Draft.js → HTML quirks.
 */
function cleanHTML(html) {
    return html
        .replace(/<p><br><\/p>/g, '<p></p>')
        .replace(/<div><br><\/div>/g, '<p></p>')
        .replace(/&nbsp;/g, ' ')
        .trim();
}

/**
 * Draft.js raw → HTML (handles base64 images, width/height)
 */
export function draftRawToHTML(draftJSONString) {
    if (!draftJSONString) return '<p></p>';

    try {
        const raw = JSON.parse(draftJSONString);

        const html = draftToHtml(raw, null, null, (entity, text) => {
            if (entity.type === 'IMAGE' && entity.data.src) {
                const alt = entity.data.alt || '';
                const width = entity.data.width ? `width="${entity.data.width}"` : '';
                const height = entity.data.height ? `height="${entity.data.height}"` : '';
                return `<img src="${entity.data.src}" alt="${alt}" ${width} ${height} style="max-width:100%;"/>`;
            }
            return text;
        });

        return cleanHTML(html);
    } catch (err) {
        console.error('Error converting Draft.js → HTML:', err);
        return '<p></p>';
    }
}

/**
 * Tiptap HTML → Draft.js raw
 * Re-creates IMAGE entity with src/alt/width/height.
 */
export function tiptapHTMLToDraftRaw(html) {
    let clean = cleanHTML(html);

     //removing nested <p> tags inside <li> tags
    //why? - Tiptap often wraps list item content in a <p> tag, but the html-to-draftjs library expects the text to be directly inside the <li>, not nested in a paragraph.
    if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = clean;
    
        // Helper function to unwrap <p> tags inside <li>
        function unwrapPTagsInListItem(li) {
            // Get only direct children of this <li>
            const children = Array.from(li.childNodes);
            const newContent = [];
            
            for (const child of children) {
                if (child.nodeName === 'P') {
                    // Unwrap <p> tag - add its innerHTML
                    newContent.push(child.innerHTML);
                } else if (child.nodeName === 'UL' || child.nodeName === 'OL') {

                    const nestedListItems = child.querySelectorAll(':scope > li');
                    nestedListItems.forEach(nestedLi => unwrapPTagsInListItem(nestedLi));
                    newContent.push(child.outerHTML);
                } else if (child.nodeType === 3) {
                    newContent.push(child.textContent);
                } else {
                    newContent.push(child.outerHTML || child.textContent);
                }
            }
            
            li.innerHTML = newContent.join('');
        }
        
        // Process all top-level lists (not nested ones)
        const topLevelLists = tempDiv.querySelectorAll('ul, ol');
        topLevelLists.forEach(list => {
            // Only process direct children (> selector)
            const directListItems = list.querySelectorAll(':scope > li');
            directListItems.forEach(li => unwrapPTagsInListItem(li));
        });
        clean = tempDiv.innerHTML;
    } else {
        // Fallback regex-based approach
        clean = clean.replace(/<li[^>]*>\s*<p[^>]*>/gi, '<li>');
        clean = clean.replace(/<\/p>\s*<\/li>/gi, '</li>');
        clean = clean.replace(/<\/p>\s*<p[^>]*>/gi, '<br/>');
    }


    const { contentBlocks, entityMap } = htmlToDraft(clean, (nodeName, node) => {
        if (nodeName === 'img') {
            return {
                type: 'IMAGE',
                mutability: 'IMMUTABLE',
                data: {
                    src: node.getAttribute('src'),
                    alt: node.getAttribute('alt') || '',
                    width: node.getAttribute('width') || '',
                    height: node.getAttribute('height') || '',
                },
            };
        }
    });

    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return convertToRaw(contentState);
}

